import React from "react";
import { ArrayField } from "../../../common/data-grid-fields/ArrayField";
import { DriverLogDetailedView } from "../../../../common/data/service-proxies";

interface Props {
  record: DriverLogDetailedView;
}

export const ShippingDocsArrayField = ({ record, ...rest }: Props) => {
  const shippingDocs = record.shippingDocs ?? [];
  const pendingShippingDocs =
    record.pendingShippingDocs?.map((x) => `${x}*`) ?? [];
  const newRecord = {
    ...record,
    shippingDocs: [...shippingDocs, ...pendingShippingDocs],
  };
  return (
    <ArrayField
      record={newRecord}
      source="shippingDocs"
      displayedElementsCount={newRecord.shippingDocs.length}
      emptyArrayDisplay=""
    />
  );
};
